import { ApiResponseType } from './api';

export enum OtpValidationType {
    Valid = 0,
    InValid = 1,
    Expired = 2,
}

export enum AccountSetupType {
    Default = 0,
    ForgotPasword = 1,
    CreatePassword = 2,
}

export enum OTPType {
    Registration,
    Consent,
    ForgotPassword,
    MigrateAccount,
    CreatePassword,
    ChangePassword,
    PolicyDocument,
    AffiliateMarketing,
    UnclaimedAccount,
}

export type userOTPResponseType = Omit<ApiResponseType, 'resultObject'> & {
    isSuccessful: boolean;
    resultObject: {
        otpValidateType: OtpValidationType;
        isEmailInvalid: boolean;
        email: string;
    };
};

export type updateOTPFormType = {
    email: string;
    otpType: OTPType;
    phone?: string;
    countryCode?: string;
    candidateId?: string;
};

export type validateOTPFormType = {
    otp: string;
    email: string;
    otpType: OTPType;
    accountType?: string;
    ipAddress?: string;
};

export type EditUserPolicyDocumentType = {
    email: string;
};

export type UploadPolicyDocumentFormType = Omit<EditUserPolicyDocumentType, 'email'> & {
    email: string;
    policyDocumentID: string;
};

export enum EsignatureStatus {
    Pending = 0,
    Verified = 1,
    NotVerified = 2,
    NewSignUp = 3,
}
